import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "Avenir Next", sans-serif;
  font-size: 14px;
  align-items: center;
  width: 100%;
  min-height: 100vh;
`;